import * as z from 'zod';

export const toilRequestFormSchema = z.object({
  // Sent to the TOIL_REQUEST workflow as `isHalfDay`.
  ToilType: z.enum(['FullDay', 'HalfDay']).default('FullDay'),
  ToilDate: z.string().min(1, { message: 'DATE_REQUIRED' }),
  Reason: z
    .string()
    .min(1, { message: 'REASON_REQUIRED' })
    .max(100, { message: 'REASON_TOO_LONG' }),
});

export type ToilRequestFormValues = z.infer<typeof toilRequestFormSchema>;
